import { InjectionToken } from '@angular/core';
import { IFilterDefinition } from '@df/catalog-ui/listing/listing';
import { IListingSizeOption } from '@df/catalog-ui/listing/size/listing-size';
import { IListingSortOption } from '@df/catalog-ui/listing/sort/listing-sort';
import { TNumberPerSize } from '@df/core/df-core.interfaces';
import { Search } from './search.interfaces';

export namespace NSearch {
    export const DEFAULT_OPTIONS: IModuleOptions = {
        blurOnLocation: true,
        embeddedMinisearch: false,
        options: {
            search: {
                autocomplete: true,
                stockCheck: true,
                product: 10,
                terms: 10,
                category: 5,
                post: 5,
                page: 5
            },
            view: {
                autocomplete: false,
                stockCheck: true,
                redirect: true,
                product: 500
            }
        },
        listing: {
            infScrollStep: 12
        }
    };

    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_SEARCH_OPTIONS', {
        providedIn: 'root',
        factory: () => DEFAULT_OPTIONS
    });

    export interface IModuleOptions {
        // if search component should loose focus on location change
        blurOnLocation: boolean;
        // if user should see results immediately on search page
        embeddedMinisearch: false;
        //
        options: {
            search: Search.IRequestOptions;
            view: Search.IRequestOptions;
        };
        // search listing config
        listing: {
            infScrollStep: number; // falls back to category settings
            filters?: (IFilterDefinition | string)[];
            sort?: IListingSortOption[]; // falls back to category settings
            size?: IListingSizeOption[]; // falls back to category settings
            defaultSize?: TNumberPerSize; // falls back to category settings
        };
    }
}
